import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { createRef } from 'react';
import { DEFAULT_ZINDEX, DISPLAY_BLOCK, DISPLAY_NONE, HIDDEN_ZINDEX, POSITION_ABSOLUTE, POSITION_STICKY, PX, SIZE_100_PERSENT, SIZE_AUTO, TRANSLATE_3D, VISIBILITY_HIDDEN, VISIBILITY_VISIBLE, ZEROS_TRANSLATE_3D, } from '../const';
let __nextId = 0;
export const getNextId = () => { return __nextId; };
const DEFAULT_ITEM_RENDERER_FACTORY = () => _jsx(_Fragment, {});
/**
 * Virtual list item component
 * @link https://github.com/DjonnyX/rcx-virtual-list/tree/main/src/lib/src/components/ng-virtual-list-item.component.ts
 * @author Evgenii Grebennikov
 * @email djonnyx@gmail.com
 */
export class VirtualListItem extends React.Component {
    get id() {
        return this._id;
    }
    get regular() { return this._regular; }
    get data() { return this._data; }
    set data(v) {
        if (this._data === v) {
            return;
        }
        this._data = v;
        this.update();
        this.setState(v => (Object.assign(Object.assign({}, v), { data: this._data })));
    }
    set regularLength(v) {
        if (this._regularLength === v) {
            return;
        }
        this._regularLength = v;
        this.update();
    }
    get regularLength() { return this._regularLength; }
    get item() {
        return this._data;
    }
    get itemId() {
        var _a;
        return (_a = this._data) === null || _a === void 0 ? void 0 : _a.id;
    }
    get element() {
        var _a;
        return (_a = this._$elementRef) === null || _a === void 0 ? void 0 : _a.current;
    }
    get renderer() { return this._renderer; }
    set renderer(v) {
        if (this._renderer !== v) {
            this._renderer = v;
            this.update();
        }
    }
    constructor(props) {
        var _a, _b;
        super(props);
        this._$elementRef = createRef();
        this._$listItemRef = createRef();
        this._regular = false;
        this._data = undefined;
        this._regularLength = SIZE_100_PERSENT;
        this._renderer = DEFAULT_ITEM_RENDERER_FACTORY;
        this._id = VirtualListItem.__nextId = VirtualListItem.__nextId === Number.MAX_SAFE_INTEGER
            ? 0 : VirtualListItem.__nextId + 1;
        this._regular = (_a = props.regular) !== null && _a !== void 0 ? _a : false;
        this._renderer = (_b = props.renderer) !== null && _b !== void 0 ? _b : DEFAULT_ITEM_RENDERER_FACTORY;
        this.state = {
            data: undefined,
        };
    }
    update() {
        const data = this._data, regular = this._regular, length = this._regularLength, element = this._$elementRef.current;
        if (data && element) {
            const styles = element.style;
            styles.zIndex = data.config.zIndex;
            if (data.config.snapped) {
                styles.transform = data.config.sticky === 1 ? ZEROS_TRANSLATE_3D : `${TRANSLATE_3D}(${data.config.isVertical ? 0 : data.measures.x}${PX}, ${data.config.isVertical ? data.measures.y : 0}${PX} , 0)`;
                if (!data.config.isSnappingMethodAdvanced) {
                    styles.position = POSITION_STICKY;
                }
            }
            else {
                styles.position = POSITION_ABSOLUTE;
                if (regular) {
                    styles.transform = `${TRANSLATE_3D}(${data.config.isVertical ? 0 : data.measures.delta}${PX}, ${data.config.isVertical ? data.measures.delta : 0}${PX} , 0)`;
                }
                else {
                    styles.transform = `${TRANSLATE_3D}(${data.config.isVertical ? 0 : data.measures.x}${PX}, ${data.config.isVertical ? data.measures.y : 0}${PX} , 0)`;
                }
            }
            styles.height = data.config.isVertical ? data.config.dynamic ? SIZE_AUTO : `${data.measures.height}${PX}` : regular ? length : SIZE_100_PERSENT;
            styles.width = data.config.isVertical ? regular ? length : SIZE_100_PERSENT : data.config.dynamic ? SIZE_AUTO : `${data.measures.width}${PX}`;
        }
    }
    getSnapshotBeforeUpdate(prevProps, prevState) {
        return null;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
    }
    shouldComponentUpdate(nextProps, nextState) {
        var _a;
        let needToUpdate = false;
        if (this._renderer !== nextProps.renderer) {
            this.renderer = (_a = nextProps.renderer) !== null && _a !== void 0 ? _a : DEFAULT_ITEM_RENDERER_FACTORY;
            needToUpdate = true;
        }
        if (this._regular !== nextProps.regular) {
            needToUpdate = true;
        }
        if (this.state !== nextState) {
            needToUpdate = true;
        }
        return needToUpdate;
    }
    getBounds() {
        var _a;
        const element = this._$elementRef.current, { width, height } = (_a = element === null || element === void 0 ? void 0 : element.getBoundingClientRect()) !== null && _a !== void 0 ? _a : { width: 0, height: 0 };
        return { width, height };
    }
    show() {
        var _a, _b, _c;
        const element = this._$elementRef.current;
        if (!element) {
            return;
        }
        const regular = this._regular, styles = element.style;
        if (regular) {
            if (styles.display === DISPLAY_BLOCK) {
                return;
            }
            styles.display = DISPLAY_BLOCK;
        }
        else {
            if (styles.visibility === VISIBILITY_VISIBLE) {
                return;
            }
            styles.visibility = VISIBILITY_VISIBLE;
        }
        styles.zIndex = styles.zIndex = (_c = (_b = (_a = this._data) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.zIndex) !== null && _c !== void 0 ? _c : DEFAULT_ZINDEX;
    }
    hide() {
        const element = this._$elementRef.current;
        if (!element) {
            return;
        }
        const regular = this._regular, styles = element.style;
        if (regular) {
            if (styles.display === DISPLAY_NONE) {
                return;
            }
            styles.display = DISPLAY_NONE;
        }
        else {
            if (styles.visibility === VISIBILITY_HIDDEN) {
                return;
            }
            styles.visibility = VISIBILITY_HIDDEN;
        }
        styles.position = POSITION_ABSOLUTE;
        styles.transform = ZEROS_TRANSLATE_3D;
        styles.zIndex = HIDDEN_ZINDEX;
    }
    classNames(data, ...classes) {
        const result = ['rcxvl__item-container', ...(classes !== null && classes !== void 0 ? classes : [])];
        if (data.config.snapped) {
            result.push('snapped');
        }
        if (data.config.snappedOut) {
            result.push('snapped-out');
        }
        return result.join(' ');
    }
    render() {
        const renderer = this._renderer, itemRenderer = { renderer }, data = this._data;
        return _jsx("div", Object.assign({ ref: this._$elementRef, className: 'rcxvl__item' }, { children: this._data &&
                _jsx("li", Object.assign({ ref: this._$listItemRef, className: this.classNames(this._data) }, { children: (renderer !== undefined || renderer !== null) && _jsx(itemRenderer.renderer, { data: data === null || data === void 0 ? void 0 : data.data, config: data === null || data === void 0 ? void 0 : data.config }) })) }));
    }
}
VirtualListItem.__nextId = 0;
